import * as Notifications from 'expo-notifications';
import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import NotificationsImage from '@assets/icons/notifications.svg';
import React from 'react';
import { ActionSheet } from './action-sheet';
import { useSaveNotificationToken } from '@/hooks/use-save-notification-token';
import { useTheme } from '@/contexts/theme-context';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  onClose: () => void;
}

export const NotificationPermissionsActionSheet: React.FC<Props> = ({
  onClose,
}) => {
  const theme = useTheme();

  const { checkAndSaveToken, isSaving } = useSaveNotificationToken();
  const { showErrorToast } = useToasts();

  return (
    <ActionSheet
      actions={[i18n.t('turn_on'), i18n.t('not_now')]}
      horizontalButtons
      imageComponent={
        <NotificationsImage
          accentFill={theme.colors.accent}
          stroke={theme.colors.primary}
        />
      }
      isVisible
      loadingActionIndex={isSaving ? 0 : null}
      message={i18n.t('notification_permissions.message')}
      onAction={async (_, index) => {
        if (index === 0) {
          Analytics.track(
            'notification_permissions_action_sheet.turn_on_button.press',
          );

          try {
            const result = await Notifications.requestPermissionsAsync();
            await checkAndSaveToken(result);
          } catch (e) {
            showErrorToast();
          }
        } else {
          Analytics.track(
            'notification_permissions_action_sheet.not_now_button.press',
          );
        }

        onClose();
      }}
      onClose={onClose}
      title={i18n.t('notification_permissions.title')}
    />
  );
};
